import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import {
  Component,
  ElementRef,
  forwardRef,
  HostBinding,
  Input,
  ViewChild
} from '@angular/core';

import { ICustomSelect, TValue } from './../../../models/generic';

@Component({
  selector: 'app-c-select',
  templateUrl: './c-select.component.html',
  styleUrls: ['./c-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CSelectComponent)
    }
  ]
})
export class CSelectComponent implements ControlValueAccessor {
  private static nextId = 0;
  readonly selectId = `c-select-${CSelectComponent.nextId++}`;
  readonly hintId = `${this.selectId}-hint`;
  readonly errorId = `${this.selectId}-error`;

  @Input() @HostBinding('style.--select-width') width?: string;
  @Input() @HostBinding('style.--select-height') height?: string;
  @Input() @HostBinding('style.--select-align') alignItem?: string;
  @Input() @HostBinding('style.--select-border-color') borderColor?: string;
  @Input() @HostBinding('style.--select-border-radius') borderRadius?: string;

  @Input() data: ICustomSelect[] = [];
  @Input() value!: TValue;
  @Input() placeholder: string = ' ';
  @Input() label: string = ' ';
  @Input() required: boolean = false;
  @Input() readonly: boolean = false;
  @Input() valueDefault: string | number = '';
  @Input() isStoreConfig: boolean = false;
  @Input() appearance: 'legacy' | 'modern' = 'legacy';
  @Input() hint: string = '';
  @Input() errorMessage: string = '';
  @Input() hasError: boolean = false;

  @ViewChild('select') selectRef!: ElementRef<HTMLSelectElement>;

  onChange = (value: TValue): void => {};

  disabled: boolean = false;

  constructor() {}

  get hasErrorState(): boolean {
    return this.hasError;
  }

  get currentErrorMessage(): string {
    if (this.errorMessage) {
      return this.errorMessage;
    }

    return 'Revise este campo.';
  }

  get describedBy(): string | null {
    if (this.hasErrorState) {
      return this.errorId;
    }

    if (this.hint) {
      return this.hintId;
    }

    return null;
  }

  writeValue(value: TValue): void {
    this.value = value;
  }

  registerOnChange(fn: (_: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
